import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('sherbet_square', {
  cherry: 'gumdrop',
  lemon: 'lemon_drop',
  orange: 'orange_slice',
  bell: 'jellybean_jar',
  star: 'sherbet_star',
  seven: 'soda_fountain',
  gem: 'rock_candy',
  scatter: 'bonbon_box',
  money: 'sweet_till',
});

/** Sherbet Square — GENERATED by scaffoldSlot from
 *  content/slots/sherbet_square.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SHERBET_SQUARE_THEME: Theme = {
  id: 'sherbet_square',
  name: 'Sherbet Square',
  palette: {
    accent: 0xff7a3c,
    secondary: 0xff5fa2,
    warm: 0xffd86b,
    frameFill: 0x3a1530,
    bgGradientTop: 0x4a1d2e,
    bgGradientBottom: 0x1c0a14,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Gumdrop', glyph: '🟣', tint: 0xff5fa2, weight: 5, textureAlias: 'sherbet_square:cherry',
        winVideoAlias: 'sherbet_square:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Lemon Drop', glyph: '🍋', tint: 0xffd86b, weight: 5, textureAlias: 'sherbet_square:lemon',
        winVideoAlias: 'sherbet_square:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Orange Slice', glyph: '🍊', tint: 0xff7a3c, weight: 4, textureAlias: 'sherbet_square:orange',
        winVideoAlias: 'sherbet_square:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Jelly-Bean Jar', glyph: '🫙', tint: 0xff5fa2, weight: 3, textureAlias: 'sherbet_square:bell',
        winVideoAlias: 'sherbet_square:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Sherbet Star', glyph: '⭐', tint: 0xffd86b, weight: 2, textureAlias: 'sherbet_square:star',
        winVideoAlias: 'sherbet_square:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Soda Fountain', glyph: '🥤', tint: 0xff7a3c, weight: 2, textureAlias: 'sherbet_square:seven',
        winVideoAlias: 'sherbet_square:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Rock Candy', glyph: '💎', tint: 0xff8fd0, weight: 2.5, textureAlias: 'sherbet_square:gem',
        winVideoAlias: 'sherbet_square:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Bonbon Box', glyph: '🎁', tint: 0xff5fa2, weight: 0.5, textureAlias: 'sherbet_square:scatter',
        winVideoAlias: 'sherbet_square:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Sweet Shop Till', glyph: '🪙', tint: 0xffd86b, weight: 1, textureAlias: 'sherbet_square:money',
        winVideoAlias: 'sherbet_square:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xff7a3c, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xff7a3c, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xff5fa2, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xff7a3c, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd86b, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xff5fa2, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0xff7a3c, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd86b, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xffd86b, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'sherbet_square:bg', path: 'environment/sherbet_square.png' },
      columnBackground: { alias: 'sherbet_square:column_bg', path: 'reel/sherbet_square_column_bg.png' },
      border: { alias: 'sherbet_square:border', path: 'brand/border_candy.png' },
    },
  },
};
